import {
    FlightUpdateData,
    IApiUpdate,
    IResponse,
    ItineraryCodeDto,
    ITodoList,
    IValueData,
    V2,
} from '@eventr/common'
import { ScreenType } from '../../v2/renderers/rendererLocator'
import { IItinerary } from '../interfaces'


export interface IAppUpdate {
    flights?: IApiUpdate<FlightUpdateData>[]
    original?: { itinName: string; codeInfo: ItineraryCodeDto }[]
    todos?: {
        [key: string]: {
            value: {
                status: 'completed' | 'incomplete'
                user_id: number
            }
            id: number
        }
    }
}
export interface CurrentItinState {
    selectedItinerary: IItinerary | undefined
    eventEnded: boolean
    past: boolean
    itineraryComponents: { past: any; present: any; todos: ITodoList[] } /// any as is obj. keys are dates, values are items in that date.
    /**
     * @deprecated use selectIsItineraryEmpty
     */
    selectedItinEmpty: boolean
    selectedItinID: number
    apiUpdates?: IAppUpdate
    // these are values for edit dont use them to render them in home screen or team only edit pages
    editValues?: IValueData
    lastUsedDateTime?: string
    timelineEntries?: any
}

export interface CurrentItinActions {
    setCurrentItin: (id: number) => Promise<void>
    setPast: (past: boolean) => void
    getEventInfoV2: () => V2 | undefined
    getCurrentEventImageUrl: () => string | undefined
    filterEntitiesUserSpecific: (
        screenType: ScreenType,
        data: V2,
        userList?: string
    ) => any[]
    getSectionV2FromSectionId: (sectionId: number) => V2 | undefined
    updateItinerarySection: (
        sectionId: number,
        newSectionData: any
    ) => Promise<boolean>
    deleteItineraryItem: (sectionId: number, itemId: string) => Promise<boolean>
    getV2Value: (valueLocator: string, data: any) => any
    getSectionV2FromSectionIdFromSelectedItinerary: (
        sectionId: number
    ) => V2 | undefined
    getApiUpdates: () => any
    removePublicItinerary: (code: string) => Promise<void>
    updateTodo: (
        taskId: string,
        status: boolean,
        fillerId?: number
    ) => Promise<void>
    pullEditValues: () => Promise<void>
    upsertElement: (sectionID: number, element: any) => Promise<IResponse<any>>
    insertEditItem: (sectionID: number, item: any) => void
    deleteElement: (
        sectionID: number,
        elementID?: string
    ) => Promise<IResponse<any>>
    setLastUsedDateTime: (dateTime: string) => void
}

export interface CurrentItinSlice
    extends CurrentItinState,
    CurrentItinActions { }

export const defaultCurrentItinSlice: CurrentItinState = {
    selectedItinID: -1,
    selectedItinerary: undefined,
    eventEnded: false,
    past: false,
    itineraryComponents: { past: {}, present: {}, todos: [] },
    selectedItinEmpty: false,
    apiUpdates: undefined,
    lastUsedDateTime: undefined,
}
